import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESTYPE,
  DELETE_SALESTYPE,
  UPDATE_SALESTYPE,
  ADD_NEW_SALESTYPE,
} from "./actionType";

import {
  getSalesTypeSuccess,
  getSalesTypeFail,
  deleteSalesTypeSuccess,
  deleteSalesTypeFail,
  updateSalesTypeSuccess,
  updateSalesTypeFail,
  addSalesTypeSuccess,
  addSalesTypeFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesTypeApi,
  getSalesTypeApi,
  updateSalesTypeApi,
  deleteSalesTypeApi,
  addNewSalesTypeApi
} from "../../helpers/backend_helper";

function* getSalesType({ payload: salesType }) {
  try {
    const response = yield call(getSalesTypeApi, salesType);
    yield put(getSalesTypeSuccess(GET_SALESTYPE, response.data));
  } catch (error) {
    yield put(getSalesTypeFail(GET_SALESTYPE, error));
  }
}

function* onUpdateSalesType({ payload: salesType }) {
  try {
    if (salesType.setApprove) {
      const response = yield call(approveSalesTypeApi, salesType);
      yield put(updateSalesTypeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesTypeApi, salesType);
      yield put(updateSalesTypeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesType({ payload: salesType }) {
  try {
    const response = yield call(deleteSalesTypeApi, salesType);
    yield put(deleteSalesTypeSuccess({ salesType, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesType({ payload: salesType }) {
  try {
    const response = yield call(addNewSalesTypeApi, salesType);
    yield put(addSalesTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesType() {
  yield takeEvery(GET_SALESTYPE, getSalesType);
}

export function* watchUpdateSalesType() {
  yield takeEvery(UPDATE_SALESTYPE, onUpdateSalesType);
}

export function* watchDeleteSalesType() {
  yield takeEvery(DELETE_SALESTYPE, onDeleteSalesType);
}

export function* watchAddNewSalesType() {
  yield takeEvery(ADD_NEW_SALESTYPE, onAddNewSalesType);
}

function* salesTypeSaga() {
  yield all([
    fork(watchGetSalesType),
    fork(watchDeleteSalesType),
    fork(watchUpdateSalesType),
    fork(watchAddNewSalesType)
  ]);
}

export default salesTypeSaga;
